var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80563 12.4264C2.9663 9.95291 4.95493 8.01446 7.43058 7.89181C11.0155 7.7142 16.1393 7.5 20 7.5C23.8607 7.5 28.9845 7.7142 32.5694 7.89181C35.0451 8.01446 37.0337 9.95291 37.1944 12.4264C37.3483 14.7962 37.5 17.7121 37.5 20C37.5 22.2879 37.3483 25.2038 37.1944 27.5736C37.0337 30.0471 35.0451 31.9855 32.5694 32.1082C28.9845 32.2858 23.8607 32.5 20 32.5C16.1393 32.5 11.0155 32.2858 7.43058 32.1082C4.95494 31.9855 2.9663 30.0471 2.80563 27.5736C2.6517 25.2038 2.5 22.2879 2.5 20C2.5 17.7121 2.6517 14.7962 2.80563 12.4264Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15V25L26.25 20L16.25 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeVideo);
export default __webpack_public_path__ + "static/media/youtube-video.fa64af21.svg";
export { ForwardRef as ReactComponent };